"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _filterDiscontinuedShade = require("./filterDiscontinuedShade");
Object.keys(_filterDiscontinuedShade).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _filterDiscontinuedShade[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _filterDiscontinuedShade[key];
    }
  });
});
var _findLabelByDomainType = require("./findLabelByDomainType");
Object.keys(_findLabelByDomainType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _findLabelByDomainType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _findLabelByDomainType[key];
    }
  });
});
var _findLabelByKey = require("./findLabelByKey");
Object.keys(_findLabelByKey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _findLabelByKey[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _findLabelByKey[key];
    }
  });
});
var _getPointsBackground = require("./getPointsBackground");
Object.keys(_getPointsBackground).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getPointsBackground[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getPointsBackground[key];
    }
  });
});
var _getProductUrl = require("./getProductUrl");
Object.keys(_getProductUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getProductUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getProductUrl[key];
    }
  });
});
var _isMultiShadeProduct = require("./isMultiShadeProduct");
Object.keys(_isMultiShadeProduct).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isMultiShadeProduct[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isMultiShadeProduct[key];
    }
  });
});
var _openProductInfoDialog = require("./openProductInfoDialog");
Object.keys(_openProductInfoDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _openProductInfoDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _openProductInfoDialog[key];
    }
  });
});
var _openShadePicker = require("./openShadePicker");
Object.keys(_openShadePicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _openShadePicker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _openShadePicker[key];
    }
  });
});
var _logMissingConceptOrName = require("./logMissingConceptOrName");
Object.keys(_logMissingConceptOrName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _logMissingConceptOrName[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _logMissingConceptOrName[key];
    }
  });
});
//# sourceMappingURL=index.js.map